import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useFacetData } from '~/context/common/FacetDataContext';
import { Label } from './FiltersMenu.styles';
import useRangeUpdater from './hooks/useRangeUpdater';
import InputRangeSlider from './InputRangeSlider';

function roundDownToNearestHundred(num: number) {
  return Math.floor(num / 100) * 100;
}

function roundUpToNearestHundred(num: number) {
  return Math.ceil(num / 100) * 100;
}

export default function Mileage() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const facetData = useFacetData();
  const minimumMileage = roundDownToNearestHundred(facetData.mileage?.min ?? 0);
  const maximumMileage = roundUpToNearestHundred(facetData.mileage?.max ?? 0);
  const [rangeValues, setRangeValues] = useState([
    appliedFilters.mileage?.min ?? minimumMileage,
    appliedFilters.mileage?.max ?? maximumMileage
  ]);

  const onUpdate = useRangeUpdater({
    filterKey: 'mileage',
    max: maximumMileage,
    min: minimumMileage
  });

  useSubsequentEffect(() => {
    setRangeValues([
      appliedFilters.mileage?.min ?? minimumMileage,
      appliedFilters.mileage?.max ?? maximumMileage
    ]);
  }, [
    appliedFilters.mileage?.max,
    appliedFilters.mileage?.min,
    maximumMileage,
    minimumMileage
  ]);

  return (
    <>
      <Label>Mileage</Label>
      <InputRangeSlider
        data-analytics-id="adjust-mpg-range"
        format="number"
        idPrefix="mileage"
        min={minimumMileage}
        max={maximumMileage}
        step={100}
        thumbBehavior="slide-through"
        value={rangeValues}
        onValueChange={value => {
          setRangeValues(value);
        }}
        onValueCommit={value => {
          onUpdate(value);
        }}
      />
    </>
  );
}
